import { Spin } from 'antd';
import cn from 'classnames';

import { PF } from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import {
  useInventoryCard,
  useInventoryCardEffects,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/hooks';
import {
  Filters,
  Header,
  History,
  Products,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/ui';

import type { FC } from 'react';

import '@pages/Warehouses/Inventory/components/InventoryCard/styles/InventoryCard.scss';

export const InventoryCard: FC = () => {
  const {
    inProgress,
    conditionOptions,
    filters,
    onChangeFilters,
    isPageLoading,
    date,
    warehouseName,
    comment,
    data,
    columns,
    pagination,
    onPaginate,
    onPageSizeChange,
    history,
    status,
    fetchedHistoryHandler,
    scrollHistoryToBottom,
    historyContainerRef,
  } = useInventoryCard();

  useInventoryCardEffects({ fetchedHistoryHandler, scrollHistoryToBottom });

  if (isPageLoading) {
    return (
      <div className={`${PF}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={PF}>
      <div
        className={cn(`${PF}_main`, { [`${PF}_main_in-progress`]: inProgress })}
      >
        <Header
          date={date}
          warehouseName={warehouseName}
          comment={comment}
          status={status}
        />
        <Filters
          values={filters}
          onChangeFilters={onChangeFilters}
          conditionOptions={conditionOptions}
        />
        <Products
          isLoading={isPageLoading}
          data={data}
          columns={columns}
          pagination={pagination}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
      {inProgress && (
        <History list={history} historyContainerRef={historyContainerRef} />
      )}
    </div>
  );
};
